import styled from 'styled-components';
import { color, fontSize, fontWeight, radius, screen, spacing } from 'theme';

export const StyledItem = styled.figure`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing('md')};
  text-align: center;
  margin: 0;
  transition: 0.3s;

  &:hover {
    opacity: 1 !important;
  }

  @media (min-width: ${screen('md')}) {
    gap: ${spacing('xl')};
  }
`;

export const StyledItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: ${spacing('xl2')};

  &:hover ${StyledItem} {
    opacity: 0.5;
  }

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    gap: ${spacing('xl4')};
    align-items: flex-end;
    max-width: min-content;
  }
`;

export const StyledCaption = styled.figcaption`
  font-weight: ${fontWeight('medium')};
  text-transform: uppercase;
  line-height: 1.25;
  white-space: nowrap;
`;

export const StyledValue = styled.div`
  border-radius: ${radius('full')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${fontSize('xl2')};
  font-weight: ${fontWeight('medium')};
  color: ${color('text_white')};

  &.big {
    width: 13.75rem;
    height: 13.75rem;
    background-color: ${color('seq_blue_08')};
  }

  &.medium {
    width: 9.125rem;
    height: 9.125rem;
    background-color: ${color('seq_blue_06')};
  }

  &.small {
    width: 6.875rem;
    height: 6.875rem;
    background-color: ${color('ylgnbu_04')};
  }
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${spacing('xl2')};
  gap: ${spacing('xl2')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    align-items: flex-start;
  }

  img {
    max-width: 15.5rem;
    border-radius: ${radius('lg')};
  }
`;

export const StyledText = styled.div`
  line-height: 1.5;

  p {
    margin-top: 0;
  }
`;
